import { Directive, Input, TemplateRef, ViewContainerRef, Inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Responsive } from '../media.service';
var MediaDirective = /** @class */ (function () {
    function MediaDirective(_viewContainer, templateRef, mediaService, platformId) {
        this._viewContainer = _viewContainer;
        this.mediaService = mediaService;
        this.platformId = platformId;
        this._TemplateRef = null;
        this._TemplateRef = templateRef;
    }
    Object.defineProperty(MediaDirective.prototype, "lyResponsive", {
        set: function (val) {
            this._media = val;
            this.updateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaDirective.prototype, "media", {
        get: function () {
            return this._media;
        },
        enumerable: true,
        configurable: true
    });
    MediaDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.view = this.mediaService.stateView().subscribe(function () {
            _this.updateView();
        });
    };
    MediaDirective.prototype.updateView = function () {
        if (isPlatformServer(this.platformId) || this.mediaService.matchMedia(this._media)) {
            if (this._viewContainer.length === 0) {
                this._viewContainer.createEmbeddedView(this._TemplateRef);
            }
        }
        else if (this._viewContainer.length !== 0) {
            this._viewContainer.clear();
        }
    };
    MediaDirective.prototype.ngOnDestroy = function () {
        if (this.view) {
            this.view.unsubscribe();
        }
    };
    MediaDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[lyResponsive]'
                },] },
    ];
    /** @nocollapse */
    MediaDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
        { type: TemplateRef, },
        { type: Responsive, },
        { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
    ]; };
    MediaDirective.propDecorators = {
        "lyResponsive": [{ type: Input },],
    };
    return MediaDirective;
}());
export { MediaDirective };
//# sourceMappingURL=media.directive.js.map